import { ControllerFlowAPI, IHttpClient } from '@wix/yoshi-flow-editor';

export type InPopulationResponse = {
  inPopulation?: boolean;
};

export type ProvisionResponse = {
  success: boolean;
};

export type AddressResponse = {
  country?: string;
  subdivision?: string;
  city?: string;
};

type ErrorHandler = ControllerFlowAPI['errorHandler'];

export class EcomServerless {
  constructor(private httpClient: IHttpClient, private errorHandler: ErrorHandler) {}

  public async isInPopulation() {
    try {
      const response = await this.errorHandler.withErrorHandler(
        () => this.httpClient.get<InPopulationResponse>(`/_api/pricing-plans-ecom/in-population`),
        { errorCodesMap: {} },
      );
      const { inPopulation } = response.data;
      return Boolean(inPopulation);
    } catch (e) {
      this.errorHandler.getResolvedError(e);
      throw e;
    }
  }

  public async provision(): Promise<void> {
    try {
      const response = await this.errorHandler.withErrorHandler(
        () => this.httpClient.post<ProvisionResponse>(`/_api/pricing-plans-ecom/provision`),
        { errorCodesMap: {} },
      );
      const { success } = response.data;
      if (!success) {
        throw new Error('Failed to add to population');
      }
    } catch (e) {
      this.errorHandler.getResolvedError(e);
      throw e;
    }
  }

  public async getAddress() {
    try {
      const response = await this.errorHandler.withErrorHandler(
        () => this.httpClient.get<AddressResponse>(`/_api/pricing-plans-ecom/address`),
        { errorCodesMap: {} },
      );
      return response.data;
    } catch (e) {
      this.errorHandler.getResolvedError(e);
      // Just swallow exception, but not sure its great...
      return {};
    }
  }
}
